<template>
  <header class="header">
    <div class="header-iri">
        <p class="header-iri__text">При поддержке</p>
      <img src="@/assets/img/iri-black.svg" alt="" class="header-iri__img">
    </div>
    <div class="header-filling container flex al-cent">
      <img src="@/assets/img/logo-new.svg" alt="" @click="$router.push({ name: 'homePage' })"
           style="cursor: pointer" class="logo"/>
      <nav class="nav flex header-desctop">
        <a href="#aboutApp" class="nav__link almost-grey">О нас</a>
        <a href="#directions" class="nav__link almost-grey">Направления реабилитации</a>
        <a href="#appDownload" class="nav__link almost-grey">Скачать приложение</a>
        <a href="#questions" class="nav__link almost-grey" v-if="false">Частые вопросы</a>
      </nav>
      <div class="header-authorization header-desctop al-cent">
        <router-link :to="{name:'dashboardPage'}"
                     class="header-authorization__login almost-grey registration">Вход
        </router-link>
        <router-link :to="{name:'dashboardPage'}"
                     class="header-authorization__registration br-rad-10 bg-red white text-cent flex">Зарегистрироваться
        </router-link>
      </div>
      <div class="menu header-mobile">
        <button @click="viewMobile = !viewMobile" class="burger header-mobile" :class="{'burger-close': viewMobile}"></button>
        <div class="menu-filling" v-if="viewMobile">
          <div class="authorization">
            <router-link :to="{name:'dashboardPage'}" class="authorization__login ">Вход
            </router-link>
            <span class="authorization__login">/</span>
            <router-link :to="{name:'dashboardPage'}" class=" authorization__login  ">
              Регистрация
            </router-link>
          </div>
          <p class="menu-filling__title">Меню</p>
          <nav class="nav flex">
            <a href="#aboutApp" class="nav__link almost-grey">О нас</a>
            <a href="#directions" class="nav__link almost-grey">Направления реабилитации</a>
            <a href="#appDownload" class="nav__link almost-grey">Скачать приложение</a>
          </nav>
          <div class="menu-bottom">
            <router-link :to="{ name: 'allCoursesCategoriesPage' }"
            class="footer-link mobile">Начать реабилитацию
          </router-link>
            <div class="footer-group-links mobile">
              <img src="@/assets/img/logo-new-white.svg" alt="" @click="$router.push({ name: 'homePage' })"
                    class="footer-logo"/>
              <div class="footer-group-links-social mt-30 flex">
                <a href="https://vk.com/poslevypiski" class="footer-social__element">
                  <img src="@/assets/img/home/footer/vk.svg" alt="" class="footer-social__element-img"/>
                </a>
                <a href="https://ok.ru/group/70000003636748" class="footer-social__element">
                  <img src="@/assets/img/home/footer/ok.svg" alt="" class="footer-social__element-img"/>
                </a>
                <a href="https://dzen.ru/poslevypiskiofficial" class="footer-social__element">
                  <img src="@/assets/img/home/footer/dsen.svg" alt="" class="footer-social__element-img"/>
                </a>
              </div>
            </div>
            <div class="footer-apps">
              <a href="https://apps.rustore.ru/app/vrt.covid.project" target="_blank"
              class="footer-apps__element footer-apps__element--ru">
            <img src="@/assets/img/ru-store.svg" alt=""/></a>
                <a target="_blank"
                href="https://apps.apple.com/ru/app/%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B2%D1%8B%D0%BF%D0%B8%D1%81%D0%BA%D0%B8/id6450714477"
                class="footer-apps__element">
              <img  src="@/assets/img/apple-new.svg" alt=""/>
            </a>
              <a target="_blank" href="https://play.google.com/store/apps/details?id=vrt.covid.project"
                class="footer-apps__element"><img 
                                                                      src="@/assets/img/google-new.svg" alt=""/></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <main class="main">
    <section class="section performance">
      <div class="performance-filling container">
        <div class="performance-left">
          <div class="performance-block">
            <div class="performance__caption">
              <h1 class="performance__caption-title">
                  Ваше здоровье <br> в одном приложении
              </h1>
            </div>
            <p class="performance__text">
                Советы по реабилитации от ведущих <br> экспертов России в одном приложении
            </p>
            <video controls preload="none" poster="@/assets/img/video-prevue-2.webp" class="performance__video">
              <source :src="appConfig.domain + '/files/data/poslevipiski_title.mp4'" type="video/mp4"/>
            </video>
          </div>
          <div class="performance-info ">
            <p class="performance-info__subtitle">Прямо сейчас проходят реабилитацию </p>
            <p class="performance-info__number">>7 500 000</p>
            <div class="performance-info-bottom">
              <img src="@/assets/img/rus.svg" alt="" class="performance-info-logo">
              <p class="performance-info__text">При поддержке комиссии <br> по здравоохранению</p>
              <router-link :to="{name:'dashboardPage'}" class="performance-info__link performance-info__link--1">Регистрация</router-link>
            </div>
          </div>
        </div>
        <div class="performance-right">
          <div class="performance-about">
            <div class="performance-about-left">
              <img src="@/assets/img/logo-small.svg" alt="" class="performance-about__logo">
              <p class="performance-about__title">Скачивайте <br> приложение <br> и берегите свое<br>  здоровье</p>
              <div class="performance-social">
                <a href="https://www.rustore.ru/catalog/app/vrt.covid.project" class="performance-social__element">
                  <img src="@/assets/img/ru-store.svg" alt="" class="performance-social__element-img"/>
                </a>
                <a href="https://apps.apple.com/ru/app/%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B2%D1%8B%D0%BF%D0%B8%D1%81%D0%BA%D0%B8/id6450714477" class="performance-social__element">
                  <img src="@/assets/img/app-store.svg" alt="" class="performance-social__element-img"/>
                </a>
                <a href="https://play.google.com/store/apps/details?id=vrt.covid.project" class="performance-social__element">
                  <img src="@/assets/img/google-store.svg" alt="" class="performance-social__element-img"/>
                </a>
              </div>
              <router-link :to="{ name: 'allCoursesCategoriesPage' }" class="performance-about__link performance-about__link--1 link ">Начать реабилитацию</router-link>
            </div>

            <div class="performance-about-right">
              <img src="@/assets/img/phone.png" alt="" class="performance-about__photo">
            </div>
          </div>
          <div class="performance-info performance-info--2">
            <p class="performance-info__subtitle">Направлений реабилитации</p>
            <p class="performance-info__number">>80</p>
            <div class="performance-info-bottom">
              <a href="#directions"  class="performance-info__link">Подробнее</a>
            </div>
          </div>
        </div>
        <router-link :to="{ name: 'allCoursesCategoriesPage' }" class="performance-about__link mobile">Начать реабилитацию</router-link>
      </div>
    </section>
<!-- 
    <section class="section help container">
      <div class="help__filling">
        <div class="help__block"></div>
        <div class="help__info">
          <p class="help__title help__title--desktop">Проект помог<br> уже
            <span class="red">5 миллионам</span> россиян! </p>
          <p class="help__title help__title--mob">Проект помог уже
            <span class="red">5 миллионам</span> <br> россиян! </p>
          <p class="help__text">Спасибо за вашу поддержку!</p>
        </div>
        <img src="@/assets/img/home/hearts.png" alt="" class="help__hearts">
      </div>
    </section> -->

    <section class="section demonstration container" id="aboutApp">
      <!-- <div class="demonstration__caption flex">
        <img src="@/assets/img/big-logo.svg" alt="" class="small-logo"/>
        <img src="@/assets/img/home/united-rf.svg" alt="" class="united">
        <p class="demonstration__support">При поддержке комиссии <br> по здравоохранению</p>
      </div> -->
      <div class="flex demonstration-caption">
        <h2 class="section__title after-discharge">
          Что такое <br> ПОСЛЕВЫПИСКИ.РФ?
        </h2>
        <img src="@/assets/img/logo-small.svg" alt="" class="demonstration__logo">
      </div>
      <div class="demonstration-grid">
        <p class="demonstration__text">ПОСЛЕВЫПИСКИ.РФ — это проект в помощь людям, переболевшим сердечно-сосудистыми заболеваниями, а также острыми вирусными инфекциями. <br>
Мы начинали работу над проектом несколько лет назад, когда в нашей стране и во всем мире множество людей столкнулись с постковидным синдромом, а сейчас сайт ПОСЛЕВЫПИСКИ.РФ дополнен практическими видеокурсами по реабилитации после перенесенных сердечно-сосудистых заболеваний. Важные рекомендации от лучших практикующих врачей найдут люди после инсульта и инфаркта миокарда.
</p>
        <p class="demonstration__text">Программа физической реабилитации и психологической поддержки составлена командой доктора медицинских наук, Героя Труда России Дениса Проценко. <br>
ПОСЛЕВЫПИСКИ.РФ — ваше здоровье в одном приложении.
</p>
      </div>
      <div class="demonstration-bottom">
        <div class="demonstration-apps   flex">
          <a href="https://www.rustore.ru/catalog/app/vrt.covid.project" class="performance-apps__element">
            <img src="@/assets/img/ru-store.svg" alt="" class="performance-apps__element-img"/>
          </a>
          <a href="https://apps.apple.com/ru/app/%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B2%D1%8B%D0%BF%D0%B8%D1%81%D0%BA%D0%B8/id6450714477" class="performance-apps__element">
            <img src="@/assets/img/app-store.svg" alt="" class="performance-apps__element-img"/>
          </a>
          <a href="https://play.google.com/store/apps/details?id=vrt.covid.project" class="performance-apps__element">
            <img src="@/assets/img/google-store.svg" alt="" class="performance-apps__element-img"/>
          </a>
        </div>

      </div>
      <!-- <div class="demonstration-bottom demonstration-bottom--2">
           <p class="section__title  example-title">Примеры интерфейса</p>
                <div class="demonstration-arrows">
          <button class="demonstration-arrows__element demonstration-arrows__element--prev" @click="goPrev">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="47.4286" y="47.4286" width="46.8571" height="46.8571" rx="23.4286" transform="rotate(-180 47.4286 47.4286)" stroke="black" stroke-width="1.14286" />
              <path d="M27.7883 33C27.5893 33 27.3903 32.9273 27.2332 32.7716L20.404 26.0025C19.2937 24.9019 19.2937 23.0955 20.404 21.995L27.2332 15.2258C27.537 14.9247 28.0397 14.9247 28.3435 15.2258C28.6472 15.5269 28.6472 16.0252 28.3435 16.3263L21.5143 23.0955C21.0115 23.5938 21.0115 24.4036 21.5143 24.9019L28.3435 31.6711C28.6472 31.9722 28.6472 32.4705 28.3435 32.7716C28.1864 32.9169 27.9873 33 27.7883 33Z" fill="black" />
            </svg>
          </button>
          <button class="demonstration-arrows__element demonstration-arrows__element--next" @click="goNext">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.571429" y="0.571429" width="46.8571" height="46.8571" rx="23.4286" stroke="black" stroke-width="1.14286" />
              <path d="M20.2117 15C20.4107 15 20.6097 15.0727 20.7668 15.2284L27.596 21.9975C28.7063 23.0981 28.7063 24.9045 27.596 26.005L20.7668 32.7742C20.463 33.0753 19.9603 33.0753 19.6565 32.7742C19.3528 32.4731 19.3528 31.9748 19.6565 31.6737L26.4857 24.9045C26.9885 24.4062 26.9885 23.5964 26.4857 23.0981L19.6565 16.3289C19.3528 16.0278 19.3528 15.5295 19.6565 15.2284C19.8136 15.0831 20.0127 15 20.2117 15Z" fill="black" />
            </svg>
          </button>
        </div>
      </div> -->
   
      <!-- <SimpleSlider ref="slider" class="slider" /> -->
    </section>

    <section class="section peculiarities container" id="directions">
      <div class="flex demonstration-caption">
        <h2 class="section__title after-discharge">
          Направления <br>
        реабилитации
        </h2>
        <img src="@/assets/img/logo-small.svg" alt="" class="demonstration__logo">
      </div>
      <div class="peculiarities-group">
        <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Ранний восстановительный период после инсульта</p>
          <p class="peculiarities-element__text">Инсульт — одно из самых распространенных и опасных заболеваний, способных привести к инвалидности и смерти. Самый сложный период у человека, перенесшего инсульт, и его близких — это первые дни после больницы. Мы хотим помочь вам, и именно для этого предлагаем посмотреть ролики о том, как ухаживать за больным, следить за его гигиеной, правильно организовать питание. Кроме того, вам будут полезны советы невролога, логопеда и нейропсихолога по восстановлению речи, голоса, памяти, слуха и зрения вашего близкого. 
</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
        <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Двигательная реабилитация после инсульта</p>
          <p class="peculiarities-element__text">Восстановить нарушения двигательных функций после перенесенного инсульта можно с помощью специальной гимнастики для рук, ног, коленей, мышц лица. На сайте проекта вы сможете вместе с нами освоить комплекс упражнений, который поможет вернуть контроль над своим телом и максимально восстановить утраченные навыки.</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
        <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Восстановительное лечение после инсульта</p>
          <p class="peculiarities-element__text">Человеку, перенесшему инсульт, потребуется длительное восстановительное лечение. Без приема лекарств и контроля за медицинскими показателями больной не сможет выздороветь и ему может грозить повторный инсульт. В роликах ведущие врачи московских клиник рассказывают о лечении артериальной гипертонии, аритмии, хирургических методах лечения.</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
        <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Вторичная профилактика инсульта</p>
          <p class="peculiarities-element__text">Вторичная профилактика инсульта снижает риск повторного развития этого заболевания на 80%, предупреждает 4 из 5 возможных инсультов. О том, как организовать питание, выбрать подходящую физическую нагрузку, контролировать массу тела людям, перенесшим инсульт, мы рассказываем в наших роликах. </p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
        <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Хирургическое лечение инфаркта миокарда</p>
          <p class="peculiarities-element__text">О причинах, симптомах и лечении инфаркта миокарда мы подробно рассказываем в наших роликах. Также вы узнаете о коронарном стентировании при инфаркте миокарда, эндоваскулярных методах лечения заболевания артерий и об особенностях образа жизни пациента с кардиостимулятором.</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
        <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Восстановительное лечение после инфаркта миокарда</p>
          <p class="peculiarities-element__text">Чтобы полностью выздороветь человеку, перенесшему инфаркт миокарда, потребуется длительное восстановительное лечение. В наших роликах мы рассказываем о необходимости приема статинов и антитромботических препаратов, о строгом контроле за медицинскими показателями — все это позволит повысить качество жизни пациента и избежать повторного инфаркта миокарда.</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
        <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Реабилитация после инфаркта миокарда</p>
          <p class="peculiarities-element__text">После перенесенного инфаркта миокарда пациенту потребуется реабилитация: именно она позволит снизить вероятность повторного инфаркта — значительно более опасного состояния. В наших роликах мы подробно рассказываем о необходимой лекарственной терапии, принципах здорового питания, специальной кардиореабилитации и других важных аспектах жизни человека в постинфарктный период.</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
                <div class="peculiarities-element">
                  <p class="peculiarities-element__subtitle">Вторичная профилактика инфаркта миокарда
        </p>
                  <p class="peculiarities-element__text">Для человека, перенесшего инфаркт миокарда, очень важно помнить о правилах вторичной профилактики этого грозного заболевания. Прежде всего это диспансерное наблюдение у врачей в поликлинике, соблюдение принципов здорового образа жизни, контроль массы тела. Обо всем этом мы рассказываем в наших роликах.
        </p>

          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
                <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Решения для сердца и сосудов после острых вирусных инфекций</p>
          <p class="peculiarities-element__text">Многие вирусы, в том числе вирусы гриппа, аденовирус, коронавирусы, энтеровирусы, могут поражать сердечную мышцу, приводя к миокардиту. Об этом опасном заболевании, а также о сердечной недостаточности, учащенном сердцебиении и других беспокоящих пациентов симптомах и состояниях вы сможете узнать, посмотрев наши ролики.</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
                <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Здоровые желудок, кишечник, печень после острых вирусных инфекций
</p>
          <p class="peculiarities-element__text">Довольно часто к острым вирусным инфекциям присоединяются бактериальные. В этом случае пациентам назначаются антибиотики, которые могут вызвать побочные эффекты в виде заболеваний ЖКТ. В наших роликах мы подробно рассказываем о том, как восстановить ЖКТ после острых вирусных инфекций, а также о роли правильного рационального питания: какие продукты ввести в рацион, а каким сразу сказать «нет».</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
                <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Помогаем коже и волосам после острых вирусных инфекций</p>
          <p class="peculiarities-element__text">На фоне острых вирусных инфекций довольно часто возникают проблемы с кожей: аллергический или себорейный дерматиты, угревая сыпь и другие малоприятные заболевания. Также после тяжелых форм гриппа и коронавирусной инфекции пациенты часто жалуются на временное выпадение волос. О том, какие витамины помогут справиться с дерматологическими проблемами и что включить в рацион, чтобы восполнить нехватку необходимых микроэлементов, рассказываем в наших роликах.</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
                <div class="peculiarities-element">
          <p class="peculiarities-element__subtitle">Решения для легких и дыхания после острых вирусных инфекций</p>
          <p class="peculiarities-element__text">Острые вирусные инфекции могут вызвать различные заболевания легких. Посмотрев наши ролики, вы узнаете о симптомах, течении и последствиях болезней органов дыхания, а также о том, как восстановить легкие после вирусной инфекции и в какой момент реабилитации можно начать практические занятия.</p>
          <router-link :to="{name:'dashboardPage'}" href="" class="peculiarities-element__link">Подробнее</router-link>
        </div>
      </div>
      <router-link :to="{ name: 'allCoursesCategoriesPage' }" class="performance-about__link peculiarities-link desctop">Начать реабилитацию</router-link>
    </section>

    <section class="section app" id="appDownload">
      <div class="app-filling container">
        <div class="app-left">
          <h4 class="app__title">
            Скачайте приложение <br> Послевыписки.рф
          </h4>
          <div class="demonstration-apps  mt-30 flex">
            <a href="https://www.rustore.ru/catalog/app/vrt.covid.project" class="performance-apps__element">
              <img src="@/assets/img/ru-store.svg" alt="" class="performance-apps__element-img"/>
            </a>
            <a href="https://apps.apple.com/ru/app/%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B2%D1%8B%D0%BF%D0%B8%D1%81%D0%BA%D0%B8/id6450714477" class="performance-apps__element">
              <img src="@/assets/img/app-store.svg" alt="" class="performance-apps__element-img"/>
            </a>
            <a href="https://play.google.com/store/apps/details?id=vrt.covid.project" class="performance-apps__element">
              <img src="@/assets/img/google-store.svg" alt="" class="performance-apps__element-img"/>
            </a>
          </div>
            <div class="advantages">
                <div class="app-advantages-element ">
                  <p class="app-advantages__title">
                    Бесплатная и быстрая регистрация
                  </p>
                  <p class="app-advantages__text">
                   Мы разработали для вас удобное приложение с простой формой регистрации пользователей, не требующей специальных навыков работы в Интернете.

                  </p>
                </div>
                <div class="app-advantages-element ">
                  <p class="app-advantages__title">Информативность</p>
                  <p class="app-advantages__text">
                   Программа реабилитации состоит из видеокурсов и практических занятий, подготовленных ведущими врачами России с большим опытом лечения пациентов после инсульта и инфаркта миокарда.
                  </p>
                </div>
                <div class="app-advantages-element ">
                  <p class="app-advantages__title">Новые возможности</p>
                  <p class="app-advantages__text">
                  Теперь вы сможете не только изучить вопросы реабилитации после инсульта и инфаркта миокарда, но и задать интересующий вас вопрос: онлайн-помощник ответит в режиме реального времени и порекомендует подходящие именно вам видеокурсы.
                  </p>
                </div>
                <div class="app-advantages-element ">
                  <p class="app-advantages__title">Дневник здоровья</p>
                  <p class="app-advantages__text">
                    Пройдя несложную систему регистрации, у вас появится возможность в дневнике здоровья фиксировать свои симптомы и медицинские показатели (вес, цифры артериального давления и многое другое), контролировать прием назначенных препаратов, а также записывать вопросы врачу, чтобы не забыть задать их на приеме.
                  </p>
                </div>
            </div>
        </div>
        <div class="app-right ">
          <img src="@/assets/img/phone-2.png" alt="Приложение" class="app__img"/>
          <img src="@/assets/img/logo-small.svg" alt="" class="app-right__decoration">
        </div>
      </div>
    </section>

    <section class="section questions container" id="questions" v-if="false">
      <img src="@/assets/img/big-logo.svg" alt="" class="small-logo"/>
      <h2 class="section__title mt-30">частые вопросы</h2>
      <div class="questions-filling mt-40 flex">
        <div class="questions-preference flex-dir-col flex">
          <div class="questions-preference__element br-red">
            <p class="preference__element-text red">Сердце</p>
          </div>
          <div class="questions-preference__element questions-preference__element-second mt-20 br-yellow">
            <p class="preference__element-text yellow">Легкие</p>
          </div>
          <div class="questions-preference__element mt-20 questions-preference__element-desctop br-purple">
            <p class="preference__element-text purple">Голова</p>
          </div>
          <div class="questions-preference__element mt-20 questions-preference__element-desctop br-yellow">
            <p class="preference__element-text yellow">Мозг</p>
          </div>
        </div>
        <div class="questions-group ml-20 flex flex-dir-col">
          <div class="questions-element flex br-red br-rad-20">
            <div class="questions-element-filling">
              <h4 class="questions-element-filling__title">Вопрос</h4>
              <p class="questions-element-filling__text">
                Ответ на вопрос. Amet minim mollit non deserunt ullamco est sit
                aliqua dolor do amet sint. Velit officia consequat duis enim
                velit mollit. Exercitation veniam consequat sunt nostrud amet.
              </p>
            </div>
            <button class="questions-element__btn questions-element__btn-active"></button>
          </div>
          <div class="questions-element mt-20 flex br-yellow br-rad-20">
            <div class="questions-element-filling">
              <h4 class="questions-element-filling__title">Вопрос</h4>
              <p class="questions-element-filling__text">
                Ответ на вопрос. Amet minim mollit non deserunt ullamco est sit
                aliqua dolor do amet sint. Velit officia consequat duis enim
                velit mollit. Exercitation veniam consequat sunt nostrud amet.
              </p>
            </div>
            <button class="questions-element__btn"></button>
          </div>
          <div class="questions-element mt-20 flex br-purple br-rad-20">
            <div class="questions-element-filling">
              <h4 class="questions-element-filling__title">Вопрос</h4>
              <p class="questions-element-filling__text">
                Ответ на вопрос. Amet minim mollit non deserunt ullamco est sit
                aliqua dolor do amet sint. Velit officia consequat duis enim
                velit mollit. Exercitation veniam consequat sunt nostrud amet.
              </p>
            </div>
            <button class="questions-element__btn"></button>
          </div>
          <div class="questions-element mt-20 flex br-red br-rad-20">
            <div class="questions-element-filling">
              <h4 class="questions-element-filling__title">Вопрос</h4>
              <p class="questions-element-filling__text">
                Ответ на вопрос. Amet minim mollit non deserunt ullamco est sit
                aliqua dolor do amet sint. Velit officia consequat duis enim
                velit mollit. Exercitation veniam consequat sunt nostrud amet.
              </p>
            </div>
            <button class="questions-element__btn"></button>
          </div>
          <div class="questions-element mt-20 flex br-yellow br-rad-20">
            <div class="questions-element-filling">
              <h4 class="questions-element-filling__title">Вопрос</h4>
              <p class="questions-element-filling__text">
                Ответ на вопрос. Amet minim mollit non deserunt ullamco est sit
                aliqua dolor do amet sint. Velit officia consequat duis enim
                velit mollit. Exercitation veniam consequat sunt nostrud amet.
              </p>
            </div>
            <button class="questions-element__btn"></button>
          </div>
          <div class="questions-element mt-20 flex br-purple br-rad-20">
            <div class="questions-element-filling">
              <h4 class="questions-element-filling__title">Вопрос</h4>
              <p class="questions-element-filling__text">
                Ответ на вопрос. Amet minim mollit non deserunt ullamco est sit
                aliqua dolor do amet sint. Velit officia consequat duis enim
                velit mollit. Exercitation veniam consequat sunt nostrud amet.
              </p>
            </div>
            <button class="questions-element__btn"></button>
          </div>
        </div>
      </div>
      <button class="questions__more btn-big m0-auto mt-40 br-red red">
        Задать вопрос
      </button>
    </section>
  </main>

  <footer class="footer">
    <div class="footer-bg">
      <div class="footer-content">
        <div class="footer-filling container">
          <div class="footer-caption">
            <div class="footer-caption-filling  container">
              <div class="footer-caption-left">
                <h4 class="footer-caption__title">
                  Начните реабилитацию <br> прямо сейчас
                </h4>
                <div class="footer-caption-bottom">
                  <router-link :to="{ name: 'allCoursesCategoriesPage' }"
                    class="footer-caption-filling__btn btn-big white bg-red">Начать реабилитацию
                  </router-link>
                </div>
              </div>  
              <div class="footer-caption-right">
                <img src="@/assets/img/footer-people.png" alt="" class="footer-caption__img">
              </div>
              <img src="@/assets/img/logo-small.svg" alt="" class="footer-caption__logo">
            </div>
          </div>
          <router-link :to="{ name: 'allCoursesCategoriesPage' }"
          class="footer-link mobile">Начать реабилитацию
        </router-link>
        <div class="footer-group-links mobile">
          <img src="@/assets/img/logo-new-white.svg" alt="" @click="$router.push({ name: 'homePage' })"
                class="footer-logo"/>
          <div class="footer-group-links-social mt-30 flex">
            <a href="https://vk.com/poslevypiski" class="footer-social__element">
              <img src="@/assets/img/home/footer/vk.svg" alt="" class="footer-social__element-img"/>
            </a>
            <a href="https://ok.ru/group/70000003636748" class="footer-social__element">
              <img src="@/assets/img/home/footer/ok.svg" alt="" class="footer-social__element-img"/>
            </a>
            <a href="https://dzen.ru/poslevypiskiofficial" class="footer-social__element">
              <img src="@/assets/img/home/footer/dsen.svg" alt="" class="footer-social__element-img"/>
            </a>
          </div>

        </div>
          <div class="footer-group ">
            <div class="footer-group-links desctop">
              <img src="@/assets/img/logo-new-white.svg" alt="" @click="$router.push({ name: 'homePage' })"
                    class="footer-logo"/>
              <div class="footer-group-links-social mt-30 flex">
                <a href="https://vk.com/poslevypiski" class="footer-social__element">
                  <img src="@/assets/img/home/footer/vk.svg" alt="" class="footer-social__element-img"/>
                </a>
                <a href="https://ok.ru/group/70000003636748" class="footer-social__element">
                  <img src="@/assets/img/home/footer/ok.svg" alt="" class="footer-social__element-img"/>
                </a>
                <a href="https://dzen.ru/poslevypiskiofficial" class="footer-social__element">
                  <img src="@/assets/img/home/footer/dsen.svg" alt="" class="footer-social__element-img"/>
                </a>
              </div>

            </div>
            <div class="footer-group-about flex flex-dir-col">
              <a href="#aboutApp" class="footer-group-about__link">О нас</a>
              <a href="#directions" class="footer-group-about__link">Направления реабилитации</a>
              <a href="#appDownload" class="footer-group-about__link">Скачать приложение</a>
              <div class="footer-group-agreements flex flex-dir-col mobile">
                <router-link :to="{ name: 'terms' }" class="footer-group-agreements__link ">Пользовательское соглашение
                </router-link>
                <router-link :to="{ name: 'privacy' }" class="footer-group-agreements__link ">Политика
                  конфиденциальности
                </router-link>
              </div>
            </div>
            <div class="footer-group-agreements flex flex-dir-col desctop">
              <router-link :to="{ name: 'terms' }" class="footer-group-agreements__link ">Пользовательское соглашение
              </router-link>
              <router-link :to="{ name: 'privacy' }" class="footer-group-agreements__link ">Политика
                конфиденциальности
              </router-link>
            </div>
            <div class="footer-apps">
              <a href="https://apps.rustore.ru/app/vrt.covid.project" target="_blank"
              class="footer-apps__element footer-apps__element--ru">
            <img src="@/assets/img/ru-store.svg" alt=""/></a>
              <div class="footer-apps-bottom">
                <a target="_blank"
                href="https://apps.apple.com/ru/app/%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B2%D1%8B%D0%BF%D0%B8%D1%81%D0%BA%D0%B8/id6450714477"
                class="footer-apps__element">
              <img  src="@/assets/img/apple-new.svg" alt=""/>
            </a>
              <a target="_blank" href="https://play.google.com/store/apps/details?id=vrt.covid.project"
                class="footer-apps__element"><img 
                                                                      src="@/assets/img/google-new.svg" alt=""/></a>
              </div>
            </div>
          </div>
          <p class="footer-group-links__scratch">
            ©Все права защищены. 2025. ПОСЛЕВЫПИСКИ.РФ
          </p>
        </div>
      </div>
    </div>
  </footer>
<!--loader--end вешай через 1.5s после загрузки страницы-->
  <div v-if="false" class="loader " :class="{'loader--end':startLoader}">
    <img src="@/assets/img/iri-white.svg" alt="ИРИ" class="loader__img">
  </div>
</template>

<script>
// import SimpleSlider from "@/components/landing/SimpleSlider.vue";
import { appConfig } from "@/lib/appConfig";
import Cookies from "js-cookie";

export default {
  name: "HomePage",
  // components: { SimpleSlider },
  props: ["link"],
  data() {
    return {
      viewMobile: false,
      startLoader: false,
      appConfig,
    };
  },
  methods: {
    goToCourses(trend) {
      Cookies.set("trend", trend);
      this.$router.push({name: "allCoursesCategoriesPage"});
    },
    goPrev() {
      this.$refs.slider.prevSlide();
    },
    goNext() {
      this.$refs.slider.nextSlide();
    }
  },
  mounted() {
    if (this.$route.hash) {
      document
          .getElementById(this.$route.hash.replace("#", ""))
          .scrollIntoView();
    }

    setTimeout(() => {
      this.startLoader = true;
    }, 1500);
  },

};
</script>

<style scoped>
html {
  background: #fff;
}

body {
  background: #f8f8f8;
}
*{
  scroll-behavior: smooth;
  font-family: 'Montserrat', sans-serif;
}

/* Loader */
.loader{
  display: flex;
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 1000;
  background: #000000;
  transition: opacity 0.5s ease;
  top: 0;
  left: 0;
}
.loader--end{
  opacity: 0;
  pointer-events: none;
}
.loader__img{
  width: 548px;
  margin: auto;
}
.header-iri{
  display: flex;
  padding: 15px 16px;
  max-width: 100%;
  width: 100%;
  background: #F4F7FB;
justify-content: center;
    gap:15px;
    align-items: center;
}
.header-iri__text{
    font-family: "Muller", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.02em;
    color: #000000;
}
.header-iri__img{
  width: 269px;
}
/* Header */
.header {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 1000;
}

.header-filling {
  padding: 20px 20px;
}

.logo {
  width: 210px;
  object-fit: contain;
  display: flex;
  flex-shrink: 0;
  position: relative;
}

.nav {
  margin-left: auto;
  position: relative;
  gap: 30px;
}

.nav__link {
  font-weight: 400;
font-size: 14px;
line-height: 100%;
color: rgba(16, 12, 64, 0.5);
}

.nav__link-right-0 {
  margin-right: 0px;
}

.header-desctop {
  display: flex;
}

.header-mobile {
  display: none;
}

.header-authorization {
  font-weight: 500;
  font-size: 14px;
  margin-left: auto;
}

.header-authorization__login {
  margin-right: 20px;
}

.header-authorization__registration {
  width: 180px;
  height: 48px;
  align-items: center;
  justify-content: center;
}

.registration {
  display: flex;
  align-items: center;
  height: 48px;
}

@media (max-width: 1200px) {
  .logo {
    width: 240px;
  }

  .nav {
    font-size: 16px;
    margin-left: auto;
  }

  .nav :last-child {
    margin-right: 0;
  }

  .header-authorization {
    margin-left: 20px;
  }
}

@media (max-width: 950px) {
  .container{
    padding: 0 16px;
  }
  .header {
    padding: 0;
  }

  .menu {
    margin-left: auto;
  }

  .header-filling {
    padding: 10px 16px ;
  }

  .header-desctop {
    display: none;
  }

  .header-mobile {
    display: flex;
  }

  .burger {
    display: flex;
    background: url(@/assets/img/burger.svg);
    width: 36px;
    height: 36px;
    flex-shrink: 0;
  }
  .burger-close{
    background: url(@/assets/img/burger-close.svg);
  }

  .menu-filling {
    transition: all 1s ease;
    position: fixed;
    width: 100%;
    height: calc(100vh - 112px);
    height: calc(100dvh - 112px);
    right: 0;
    top: 112px;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding-top: 40px;
    overflow: auto;
  }



  .authorization {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 8px;
  }
  
  .authorization__login {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    color: #100c40;
  }
  .menu-filling__title{
    margin-top: 50px;
    width: 100%;
    text-align: center;
    font-size: 30px;
    line-height: 120%;
    text-transform: uppercase;
    color: #100c40;
    font-family: "PT";
    font-weight: 700;
  }

  .header-authorization__registration {
    margin: 20px auto 0 auto;
  }
  
  .nav {
    margin-top: 50px;
    flex-direction: column;
    text-align: center;
    width: 100%;
    margin-bottom: 20px;
  }

  .nav__link {
    margin-right: 0;
    font-size: 18px;
    font-size: 20px;
    line-height: 120%;
    text-align: center;
    color: #100c40;
  }
  .menu-bottom{
    margin-top: auto;
    padding: 20px 20px 30px 20px;
    border-radius: 10px 10px 0 0;
    width: 100%;
    background: #100c40;
  }
  .menu-bottom .footer-group-links{
    margin-top: 30px;
  }
  .menu-bottom .footer-apps{
    margin-top: 30px;
    flex-direction: row;
    display: flex;
    width: 100%;
    max-width: 100%;
    gap: 8px;
  }
  .menu-bottom .footer-apps-bottom{
    flex-direction: row;
  }

  .nav__link-right-0 {
    margin-bottom: 0px;
  }

  .header-authorization__login {
    margin-bottom: 20px;
  }

}

/* /Header */
body {
  margin-bottom: 0;
  position: relative;
  background: #ffffff !important;
}

main {
  position: relative;
  background: #fff;
  overflow: hidden;
}

main::after {
  content: "";
  position: absolute;
  background-repeat: no-repeat;
  width: 100%;
  height: 1060px;
  right: 0;
  top: 140px;
  display: block;
  background: url(@/assets/img/home-section-1-bg.webp);
  background-position-x: 0%;
  background-position-y: 0%;
  background-repeat: repeat;
  z-index: 10;
  content: "";
  position: absolute;
  background-repeat: no-repeat;
  max-width: 100%;
  background-position: right;
  pointer-events: none;
}

.section {
  padding-top: 97px;
}

.performance {
  width: 100%;
  padding-top: 194px;
  padding-bottom: 0px;
  background-size: cover;
  position: relative;
}

.performance-filling {
  display: flex;
  gap: 20px;
}

.performance-left {
  max-width: 100%;
  width: 100%;
}

.performance-right {
  max-width: 380px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.performance__video {
  margin-top: 63px;
  max-width: 100%;
  width: 100%;
  border-radius: 10px;
  object-position: center;
  object-fit: cover;
  position: relative;
  z-index: 100;
}

.performance__caption {
  position: relative;
}

.performance-social__element {
  margin-right: 10px;
}

.performance__caption-title {
  font-family: "PT";
  font-weight: 700;
  font-size: 44px;
  line-height: 1.2;
  text-transform: uppercase;
  color: #100c40;
}

.performance-after {
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  color: #ff2031;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 53px;
  border: 1px solid #ff2031;
  border-radius: 10px;
  position: absolute;
  left: 450px;
  top: 108px;
}

.performance__text {
  margin-top: 25px;
  position: relative;
  z-index: 2;
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;
  color: #100c40;
}

.performance-btns {
  margin-top: 24px;
}

.performance-btns__element {
  max-width: 250px;
  height: 60px;
}

.performance-apps {
  margin-top: 41px;
  display: flex;
  gap: 20px;
}
.performance-info{
  margin-top: 26px;
  border: 1px solid #ff2031;
  border-radius: 10px;
  padding: 24px;
  min-height: 284px;
  display: flex;
  flex-direction: column;
}
.performance-info__subtitle{
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;
  color: #100c40;
}
.performance-info__number{
  font-weight: 700;
  font-size: 64px;
  line-height: 120%;
  text-transform: uppercase;
  color: #ff2031;
  font-family: "PT";
}
.performance-info-bottom{
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 35px;
}
.performance-info__text{
  font-size: 16px;
  line-height: 125%;
  color: rgba(16, 12, 64, 0.7);
}
.performance-info__link{
  border-radius: 8px;
  padding: 16px 47px;
  width: 160px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #ff2031;
  border: 1px solid #ff2031;
  margin-left: auto;
  transition: all 0.5s ease-in-out;
}
.performance-info__link:hover{
  background: #ff2031;
  color: #fff;
  opacity: 1;
}
.performance-about{
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  z-index: 11;
  border-radius: 10px;
  box-shadow: 0 20px 60px 0 rgba(50, 50, 50, 0.08);
  background: #fff;
  padding: 33px 29px 39px 37px;
  height: 100%;
  align-items: flex-start;
}
.performance-social{
  margin-bottom:10px;
}
.performance-about-left{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.performance-about__logo{
  width: 57px;
}
.performance-about__photo{
  position: absolute;
  transform: rotate(4deg);
  right: -49px;
  top: -11px;
}
.performance-about__title{
  margin-top: 23px;
  font-weight: 400;
font-size: 16px;
line-height: 100%;
color: #100c40;
}
.performance-social{
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.performance-social__element{
  display: flex;
  
}

.performance-about__link{
  margin-top: auto;
  width: 100%;
  max-width: 100%;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ff2031;
  border-radius: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  color: #fff;
}
.apps__aplle {
  height: 50px;
  box-shadow: 0px 15px 30px rgba(85, 85, 85, 0.08);
}

.margin-0-20 {
  margin: 0 20px;
}

.apps__google {
  height: 50px;
  box-shadow: 0px 15px 30px rgba(85, 85, 85, 0.08);
}

.performance-apps__element {
  height: 50px;
  object-fit: contain;
}

/* Help */
.help {
  padding-top: 60px;
  position: relative;
  z-index: 11;
}

.help__filling {
  display: flex;
  align-items: center;
  border-radius: 20px;
  background: #F4F7FB;
  background-image: url("@/assets/img/home/help-bg.png");
  background-size: cover;

}
.help__title--mob{
  display: none;
}
.help__block {
  border-radius: 20px 0 0 20px;
  max-width: 404px;
  width: 100%;
}

.help__info {
  padding: 10px 0;
  margin-left: 61px;
}

.help__title {
  color: #000;
  font-family: "Muller", sans-serif;
  font-size: 34px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.68px;
}

.help__text {
  margin-top: 8px;
  color: #000;
  font-family: "Muller", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
}

.help__hearts {
  margin-left: auto;
  margin-right: 81px;
}

/* Demonstration */
.small-logo {
  width: 54px;
}

.section__title {
  font-size: 36px;
  line-height: 120%;
  text-transform: uppercase;
  color: #100c40;
  font-weight: 700;
  font-family: "PT";
}

.peculiarities-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 40px;
}

.section__text {
  max-width: 100%;
}

.section__ul li {
  margin-left: 0;
  font-size: 16px;
  line-height: 1.8;
}

.section__ul li::before {
  width: 3px;
  height: 3px;
  top: 12px;
}

.demonstration {
  padding-top: 76px;
  padding-bottom: 0;
}
.demonstration__caption{
  align-items: center;
}
.united{
  margin-left: 20px;
}
.demonstration__support{
  margin-left: 24px;
  color: #100C40;
  font-family: "Muller", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.32px;
}
.demonstration__logo{
  width: 127px;
  margin-left: auto;
}
.demonstration-caption{
  align-items: center;
}
.demonstration-grid{
  margin-top: 33px;
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 20px;
}
.demonstration__text{
  font-weight: 400;
  font-size: 16px;
  line-height: 155%;
  color: rgba(16, 12, 64, 0.7);
}
.demonstration-bottom{
  margin-top: 42px;
  display: flex;
  justify-content: space-between;
}
.demonstration-apps{
  gap: 16px;
}
.demonstration-arrows{
  display: flex;
  gap: 30px;
}
.demonstration-arrows__element{
  display: flex;
}
.example-title{
}
.slider{
  margin-top: 57px;
}
.statistics__subtitle {
  font-size: 16px;
  line-height: 1;
  color: rgba(16, 12, 64, 0.4000000059604645);
}

.statistics__title {
  font-weight: 500;
  font-size: 48px;
  line-height: 1;
}

.statistics__text {
  font-size: 16px;
  line-height: 1.4;
  color: rgba(16, 12, 64, 0.699999988079071);
}

/* Peculiarities */
.peculiarities {
  padding-top: 100px;
  padding-bottom: 0;
}

.peculiarities-group {
  margin-top: 42px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.peculiarities-element{
  width: 100%;
  box-shadow: 0 20px 60px 0 rgba(50, 50, 50, 0.08);
  background: #fff;
  border-radius: 10px;
  padding: 33px 32px 37px 39px;
  display: flex;
  flex-direction: column;
  min-height: 397px;
}
.peculiarities-element__subtitle{
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;
  text-transform: uppercase;
  color: #100c40;
  font-family: "PT";
  font-weight: 700;
  min-height: 87px;
}
.peculiarities-element__text{
  margin-top: 33px;
  font-size: 16px;
  line-height: 155%;
  color: rgba(16, 12, 64, 0.7);
  margin-bottom: 16px;
}
.peculiarities-element__link{
  margin-top: auto;
  border-radius: 8px;
  padding: 16px 47px;
  max-width: 160px;
  width: 100%;
  height: 44px;
  border: 1px solid #ff2031;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  color: #ff2031;
  transition: all 0.5s ease-in-out;
}
.peculiarities-element__link:hover{
  background: #ff2031;
  color: #fff;
  opacity: 1;
}
.peculiarities-link{
  margin: 42px auto 0 auto;
}
/* app */
.app {
  padding-bottom: 90px;
}

.app-filling {
  display: flex;
  align-items: flex-start;
  gap: 56px;
}

.app-left {
  max-width: 100%;
  width: 100%;
}

.app__title {
  font-size: 36px;
  line-height: 1.2;
  text-transform: uppercase;
  color: #100c40;
  font-family: "PT";
  font-weight: 700;
}


.advantages {
  margin-top: 34px;
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 20px;
}

.app-advantages-element {
  box-shadow: 0 20px 60px 0 rgba(50, 50, 50, 0.08);
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 32px 29px 40px 39px;
}

.app-advantages__title{
  font-weight: 700;
  font-size: 16px;
  line-height: 155%;
  color: rgba(16, 12, 64, 0.7);
  font-family: "PT";
  margin-bottom: 42px;
}
.app-advantages__text{
  margin-top: auto;
  font-weight: 400;
  font-size: 16px;
  line-height: 155%;
  color: rgba(16, 12, 64, 0.7);
}

.app-right {
  margin-left: auto;
  position: relative;
  max-width: 297px;
  width: 100%;
  display: flex;
  flex-shrink: 0;
}

.app__img {
width: 100%;
position: relative;
z-index: 2;
margin-top: 27px;
}
.app-right__decoration{
  position: absolute;
  z-index: 1;
  width: 127px;
  right: -43px;
}
/* /app */

/* questions */
.questions {
  padding-bottom: 74px;
}

.questions-filling {
  max-width: 100%;
  width: 100%;
}

.questions-preference__element {
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.04);
  font-family: "PT";
  text-transform: uppercase;
  font-weight: 700;
}

.preference__element-text {
  font-size: 24px;
  line-height: 1.2;
}

.questions-group {
  max-width: 100%;
  width: 100%;
}

.questions-preference {
  max-width: 280px;
  width: 100%;
}

.questions-element {
  padding: 30px 20px;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 100%;
}

.questions-element__btn {
  background: url(@/assets/img/home/questions/arrow-not-active.svg);
  width: 24px;
  height: 24px;
  background-size: contain;
  display: flex;
  flex-shrink: 0;
}

.questions-element__btn-active {
  background: url(@/assets/img/home/questions/arrow-active.svg);
}

.questions-element-filling__title {
  font-weight: 500;
  font-size: 20px;
  line-height: 1;
  color: #100c40;
}

.questions-element-filling__text {
  max-width: 580px;
  margin-top: 30px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.8;
  color: rgba(16, 12, 64, 0.6000000238418579);
}

.questions__more {
  margin-top: 30px;
}

/* footer */
.footer {
  overflow-x: hidden;
  overflow-y: visible;
  background: #fff;
}

.footer-content {
  margin: 10px;
}

.footer-logo {
  cursor: pointer;
  width: 336px;
  object-fit: contain;
}

.footer-social__element {
  margin-right: 10px;
  display: flex;
}

.footer-bg {
  background: #110d40;
  margin: 20px;
  padding-top: 234px;
  border: 1px solid #110d40;
  border-radius: 20px;
  position: relative;
  margin-top: 160px;
  padding-bottom: 20px;
}

.footer-caption {
  position: absolute;
  top: -350px;
  width: 100%;
  left: 0;
}

.footer-caption-filling {
  background: #fff;
  box-shadow: 0 40px 140px 0 rgba(0, 0, 0, 0.06);
  background: #fff;
  border-radius: 10px;
  padding: 26px 29px 29px 39px;
  display: flex;
  position: relative;
  gap: 34px;
}
.footer-caption-left{
  max-width: 100%;
  width: 100%;
}
.footer-caption__title{
  font-family: "PT";
  font-size: 36px;
line-height: 120%;
text-transform: uppercase;
color: #100c40;
font-weight: 700;
}
.footer-caption__logo{
  position: absolute;
  width: 127px;
  right: 0;
  top: -44px;
}
.footer-caption-bottom{
  width: 100%;
  margin-top: 45px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.footer-caption__text{
  max-width: 254px;
  font-weight: 400;
font-size: 16px;
line-height: 155%;
color: rgba(16, 12, 64, 0.7);
}
.footer-caption-filling__btn{
  margin-top: 1px;
}
.footer-caption-right{
  max-width: 387px;
  position: relative;
  width: 100%;
}
.footer-caption__img{
  position: absolute;
  bottom: -29px;
}

.footer-filling {
  position: relative;
}

.footer-caption-left__text {
  max-width: 410px;
  font-size: 16px;
  line-height: 1.6;
  color: rgba(16, 12, 64, 0.699999988079071);
}

.footer-group-links__scratch {
  margin-top: 65px;
  font-weight: 400;
  font-size: 12px;
  line-height: 160%;
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  padding-left: 60px;
}

.footer-group {
  gap: 16px;
  display: flex;
  align-items: flex-end;
}

.footer-group-top {
  max-width: 100%;
  width: 100%;
  justify-content: space-between;
  gap: 20px;
}

.footer-group-about{
  margin-left: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-group-about__link {
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #fff;
}

.footer-group-agreements {
  margin-left: 48px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-group-agreements__link {
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  color: #fff;
}

.footer-apps {
  margin-left: auto;
  max-width: 183px;
  width: 100%;
}
.footer-apps__element{
  display: flex;
  width: 100%;
  max-width: 100%;
}
.footer-apps__element img{
  width: 100%;
  height: auto;
}
.footer-apps-bottom{
  display: grid;
  grid-template-columns: repeat(2,1fr);
  margin-top: 15px;
  gap: 12px;
}
.apps__google-footer {
  margin-top: 20px;
  margin-left: 0;
}

.footer-mobile {
  display: none;
}

.mobile {
  display: none;
}
@media (max-width: 1100px) {
  .help__title{
    font-size: 28px;
    line-height: 100%;
  }
  .help__text{
    font-size: 18px;
  }
  .peculiarities-group{
    grid-template-columns: repeat(2,1fr);
  }
  .footer-caption{
    top: -414px;
  }
  .footer-bg{
    padding-top: 295px;
  }
}
@media (max-width: 950px) {

  main::after {
    background: url(@/assets/img/home-section-1-bg-mob.svg);
    width: 575px;
    background-size: contain;
    top: 113px;
    background-repeat: no-repeat;
  }

  .loader__img{
    width: 268px;
  }
  .header-iri{
    padding: 18px 10px;
      gap: 10px;
  }
    .header-iri__text{
        font-size: 12px;
    }
  .header-iri__img{
    width: 210px;
  }

  .mobile {
    display: flex;
  }

  .container {
    max-width: 520px;
  }

  .section {
    padding-top: 40px;
  }
  .btn-big {
    max-width: 400px;
    height: 56px;
    font-size: 14px;
  }

  .mt-30 {
    margin-top: 20px;
  }

  .mt-40 {
    margin-top: 20px;
  }

  /* performance */
  .performance {
    padding-top: 138px;
  }

  .performance-btns-second {
    margin-left: 0px;
    margin-top: 20px;
  }

  .performance__caption {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .performance-filling{
    flex-direction: column;
    gap: 0;
  }

  .performance-block{
    display: flex;
    flex-direction: column;
  }

  .performance-after {
    position: relative;
    top: 0;
    left: 0;
    margin: 0 auto;
    width: 180px;
    height: 34px;
    border-radius: 6px;
    font-size: 10px;
  }

  .performance__caption-title {
    margin-top: 30px;
    font-size: 30px;
  }

  .performance__caption{
    order: 2;
  }

  .performance__text {
    margin-top: 15px;
    font-size: 16px;
    line-height: 120%;
    color: #100c40;
    order: 3;
  }

  .performance-info{
    margin-top: 30px;
    padding: 30px 10px 30px 16px;
    min-height: 188px;
  } 
  .performance-info__subtitle{
    font-size: 16px;
  }
  .performance-info__number{
    margin-top: 7px;
    font-size: 32px;
    line-height: 120%;
  }
  .performance-info-bottom{
    margin-top: 30px;
    gap: 24px;
  }
  .performance-info__link--1{
    display: none;
  }
  .performance-info-logo{
    width: 133px;
  }
  .performance-info__text{
    font-size: 12px;
    line-height: 125%;
    color: rgba(16, 12, 64, 0.7);
  }

  .performance__video {
    margin-top: 0;
    order: 1;
  }

  .performance-right{
    max-width: 100%;
    flex-direction: column-reverse;
  }
  .performance-info--2{
    margin-top: 30px;
    padding-bottom: 13px;
    min-height: 181px;
  }
  .performance-info--2 .performance-info-bottom{
    margin-top: 25px;
  }
  .performance-about{
    margin-top: 80px;
    box-shadow: none;
    padding: 0;
    display: flex;
    flex-direction: row;
    max-width: 100%;
    gap: 23px;
    justify-content: space-between;
  }
  .performance-about-left{
    margin-top: 13px;
  }
  .performance-about__text{
    display: none;
  }
  .performance-about__photo{
    position: relative;
    transform: rotate(0);
    right: unset;
    top: unset;
    max-width: 159px;
  }
  .performance-about__link{
    margin-top: 29px;
    max-width: 100%;
  }
  .performance-about__link--1{
    display: none;
  }
  .slider{
    margin-top: 30px;
  }
  .peculiarities{
    overflow: visible;
    padding: 80px 0 0 0;
  }
  .peculiarities .section__title{
    padding: 0 16px;
  }
  .peculiarities-group{
    margin-top: 0;
    display: flex;
    overflow: auto;
    padding: 30px 16px 66px 16px;
  }
  .peculiarities-element{
    min-height: 433px;
    padding: 30px 25px 30px 30px ;
    max-width: 279px;
    width: 100%;
    flex-shrink: 0;
  }
  .peculiarities-element__subtitle{
    font-size: 18px;
  }
  .peculiarities-element__text{
    margin-top: 30px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .prculirities{
    box-shadow: 0 20px 60px 0 rgba(50, 50, 50, 0.08);
  }
  /* demonstration */
  .demonstration {
    padding-top: 80px;
  }
  .demonstration__logo{
    display: none;
  }
  .section__title{
    font-size: 25px;
    word-break: break-word;
  }
  .demonstration-grid{
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .demonstration-bottom{
    display: none;
  }
    .demonstration-bottom--2{
    display: flex;
  }
  .demonstration-arrows{
    display: none;
  }

  .mr-0-last {
    margin-right: 0;
  }

  /* app */
  .app {
    padding-top: 16px;
    padding-bottom: 0;
  }

  .app-left {
    max-width: 100%;
    margin-right: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .app-right{
    display: none;
  }

  .app__title {
    font-size: 25px;
    word-break: break-word;
    padding: 0 16px;
    width: 100%;
  }
  .app-filling{
    padding: 0;
  }
  .app .performance-apps__element{
    width: 104px;
    height: unset;
    display: flex;
  }
  .app .performance-apps__element-img{
    width: 100%;
  }
  .app .demonstration-apps{
    flex-wrap: wrap;
    gap: 7px;
    padding: 0 16px;
    width: 100%;
  }

  .advantages{
    margin-top: 0;
    overflow: auto;
    display: flex;
    padding: 30px 16px 50px 16px;
    width: 100%;
    gap: 10px;
  }
  .app-advantages-element{
    max-width: 278px;
    flex-shrink: 0;
    padding: 30px 27px 30px 30px;
  }
  /* /app */
  
  /* footer */

.footer-content {
  margin: 16px;
}


.footer-bg {
  background: #110d40;
  margin: 312px 0 0 0 ;
  padding-top: 75px;
  border-radius: 10px 10px 0 0;
  padding-bottom: 12px;
}

.footer-caption {
  position: absolute;
  top: -380px;
  width: 100%;
  left: 0;
}

.footer-caption-filling {
  padding: 30px 30px 52px 30px;
  flex-direction: column;
  min-height: 327px;
}
.footer-caption-left{
  max-width: 100%;
  width: 100%;
}
.footer-caption__title{
  font-size: 25px;
}
.footer-caption__logo{
  width: 93px;
  right: 17px;
  top: -15px;
}
.footer-caption-bottom{
  margin-top: 20px;
  width: 133px;
}

.footer-caption-filling__btn{
  display: none;
}
.footer-caption-right{
  position: absolute;
  bottom: 0;
  max-width: 100%;
  left: 0;
}
.footer-caption__img{
  bottom: 0;
  width: 289px;
  right: -57px;
}

.footer-filling {
  position: relative;
}

.footer-caption-left__text {
  max-width: 410px;
  font-size: 16px;
  line-height: 1.6;
  color: rgba(16, 12, 64, 0.699999988079071);
}
.footer-group-links{
  margin-top: 50px;
  align-items: center;
  justify-content: space-between;
}
.footer-logo{
  width: 158px;
}
.footer-group-links-social{
  margin-top: 0;
}
.footer-group-links-social{
  display: flex;
}
.footer-group-links__scratch {
  margin-top: 50px;
  padding-left: 00px;
}
.footer-filling{
  padding: 0;
}

.footer-group {
  margin-top: 44px;
  align-items: center;
}

.footer-group-top {
  max-width: 100%;
  width: 100%;
  justify-content: space-between;
  gap: 20px;
}

.footer-group-about{
  flex-direction: column;
  gap: 10px;
  margin-left: 0;
}

.footer-link{
  border-radius: 8px;
  box-shadow: 0 15px 30px 0 rgba(85, 85, 85, 0.1);
  background: #ff2031;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 66px;
}


.footer-group-agreements {
  margin-top: 33px;
  margin-left: 0;
  flex-direction: column;
  gap: 10px;
}

.footer-apps {
  margin-left: auto;
  max-width: 105px;
  width: 100%;
}
.footer-apps__element{
  display: flex;
  width: 100%;
  max-width: 100%;
}
.footer-apps__element img{
  width: 100%;
  height: auto;
}
.footer-apps-bottom{
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  gap: 10px;
}

  .mt-0 {
    margin-top: 0;
  }

  .apps__google-footer {
    margin-top: 0px;
    margin-right: 0;
    margin-left: 20px;
  }
}

@media (max-width: 470px) {
  .apps__google {
    margin-top: 20px;
  }
}
@media (max-width: 370px) {
  .help__filling{
    padding: 10px 6px;
    background-position-x: -40px;
  }
}
@media (max-width: 340px) {
  .performance-apps__element {
    height: 40px;
    width: 109px;
  }

  .apps__aplle {
    height: 40px;
  }

  .apps__google {
    height: 40px;
  }
}

.mobile{
  display: none;
}
@media (max-width: 950px) {
  .mobile{
    display: flex ;
  }
  .desctop{
    display: none;
  }
}
</style>
